export default __webpack_public_path__ + "static/media/us.40b6fd8a.svg";